require("./graphic");

var _zrender = require("../zrender");

var registerPainter = _zrender.registerPainter;

var Painter = require("./Painter");

registerPainter('vml', Painter);


//////////////////
// WEBPACK FOOTER
// ./~/_zrender@4.3.2@zrender/lib/vml/vml.js
// module id = 1386
// module chunks = 5